import { RouteType } from "types/RouteType";
import { castStoneRoutes } from "@intrasync/cast-stone";

// The package's RouteType is structurally compatible with the host's; the cast
// bridges the two copies of the shared type (same pattern as designer/accounting).
const castStoneRoutesList: RouteType[] = castStoneRoutes as unknown as RouteType[];

export default castStoneRoutesList;
